import { createSlice } from '@reduxjs/toolkit'

const initialState = []

const partTableSlice = createSlice({
  name: 'partTable',
  initialState,
  reducers: {
    partAdded(state, action) {
      state.push(action.payload)
    },
    partDeleted(state, action) {
      return state.filter((pieza) => pieza.numeroPieza !== action.payload);
    }
  }
})

export const { partAdded, partDeleted } = partTableSlice.actions

export default partTableSlice.reducer